import { TooltipProvider } from '@/common/components/ui/tooltip';
import { StatusTimelineBar } from '@/features/telemetry/components/status-timeline/subcomponents/status-timeline-bar/StatusTimelineBar';
import type { StatusSegment } from '@/features/telemetry/mappers/toStatusSegments';

export interface StatusTimelineChannel {
  key: string;
  label: string;
  segments: StatusSegment[];
}

export interface StatusTimelineProps {
  channels: StatusTimelineChannel[];
  from: Date;
  to: Date;
}

/**
 * One timeline bar per status channel a device exposes. Renders nothing when a device
 * has no status channels at all, so a card without any doesn't reserve empty space.
 */
export function StatusTimeline({ channels, from, to }: StatusTimelineProps) {
  if (channels.length === 0) return null;

  return (
    <TooltipProvider delayDuration={100}>
      <div className="space-y-2 pt-1">
        {channels.map((channel) => (
          <StatusTimelineBar
            key={channel.key}
            label={channel.label}
            segments={channel.segments}
            from={from}
            to={to}
          />
        ))}
      </div>
    </TooltipProvider>
  );
}
